import type {Tier} from '$lib/classes/_types/tier';
import {type ToastManager} from '$lib/classes/stores/toast-manager.svelte';
import type {PaymentService} from '$lib/classes/services/payment-service';

const legacyTiers: Tier[] = [
    {
        planName: 'Bronze',
        month: '1 - 3',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_BRONZE_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
    {
        planName: 'Silver',
        month: '4 - 6',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_SILVER_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
    {
        planName: 'Gold',
        month: '7 - 12',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_GOLD_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
    {
        planName: 'Platinum',
        month: '12+',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_PLATINUM_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    }
]

const tiers: Tier[] = [
    {
        planName: 'Flex',
        month: '',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_MONTHLY_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
    {
        planName: 'Plus',
        month: '',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_QUARTERLY_MONTHLY_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
    {
        planName: 'Max',
        month: '',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_ANNUAL_MONTHLY_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
    {
        planName: 'Plus-Aggregated',
        month: '',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_QUARTERLY_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
    {
        planName: 'Max-Aggregated',
        month: '',
        quantity: 1,
        priceId: import.meta.env.VITE_PADDLE_PRO_ANNUAL_PRICE_ID,
        price: null,
        lessPercentThanInitialPrice: null,
    },
]

export class TierManager {
    private _legacyTiers: Tier[] = $state(legacyTiers)

    get legacyTiers() { return this._legacyTiers }

    private _tiers: Tier[] = $state(tiers)
    get tiers() { return this._tiers }

    constructor(
        private readonly paymentService: PaymentService,
        private readonly toastManager: ToastManager
    ) {}

    async loadLegacyPrices() {
        try {
            this._legacyTiers = await this.paymentService.getPrices(this._legacyTiers)
        } catch (error) {
            console.error('ERROR loading LEGACY prices', error)
            this.toastManager.addErrorLoadingPricesToast()
        }
    }

    async loadPrices() {
        try {
            this._tiers = await this.paymentService.getPrices(this._tiers)
        } catch (error) {
            console.error('ERROR loading prices', error)
            this.toastManager.addErrorLoadingPricesToast()
        }
    }
}